import HoneycombSdk from '@wix/thunderbolt-elements/src/components/Honeycomb/corvid/Honeycomb.corvid';


const Honeycomb = {
  sdk: HoneycombSdk
};


export const components = {
  ['Honeycomb']: Honeycomb
};

